'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiHeartOutline = function TiHeartOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 33.3c-0.3 0-0.7-0.1-0.9-0.3-0.4-0.2-9.2-6.2-11.9-8.9-3.1-3.1-3.4-6.3-3.4-8.5 0-4.9 4-8.9 8.9-8.9 3 0 5.7 1.5 7.3 3.7 1.6-2.2 4.3-3.7 7.3-3.7 4.9 0 9 4 9 8.9 0 2.2-0.4 5.4-3.5 8.5-2.7 2.7-11.5 8.7-11.9 8.9-0.2 0.2-0.6 0.3-0.9 0.3z m-7.3-23.3c-3.1 0-5.6 2.5-5.6 5.6 0 1.8 0.3 4 2.4 6.1 2 2.1 8.2 6.3 10.5 7.9 2.4-1.6 8.5-5.8 10.5-7.9 2.1-2.1 2.4-4.3 2.4-6.1 0-3.1-2.5-5.6-5.6-5.6s-5.6 2.5-5.6 5.6c0 0.9-0.8 1.7-1.7 1.7s-1.7-0.8-1.7-1.7c0-3.1-2.5-5.6-5.6-5.6z' })
        )
    );
};

exports.default = TiHeartOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/heart-outline.js
// module id = 3618
// module chunks = 0